export const ANNOTATION_FONT_FAMILY = 'Inter, sans-serif';
export const ANNOTATION_FONT_SIZE = 16;
export const ANNOTATION_LINE_WIDTH = 2;
